/* eslint react/no-danger: 0 */

import PropTypes from 'prop-types';
import React from 'react';
import { sanitizeContent } from '../utils/helper';

import '../global-sass/main.scss';

const renderSpecDescription = (prefs, specIds, specObj) =>
	specIds.map(id => {
		const specDescription = (specObj[id] && specObj[id].description) || '';
		const specDetail = (specObj[id] && specObj[id].detail) || '';
		const specDisclaimers = (specObj[id] && specObj[id].disclaimers) || '';
		const specItemDescriptionClasses = ['spec-item-description'];

		const {
			disclaimerFontSize = 'xxsmall',
			isSpecDescriptionMuted = 'true'
		} = prefs;

		let sanitizedSpecDescription = sanitizeContent(specDescription);
		const sanitizedSpecDetail = specDetail && sanitizeContent(specDetail);
		const sanitizedSpecDisclaimers =
			specDisclaimers && sanitizeContent(specDisclaimers);

		if (specDetail) {
			sanitizedSpecDescription = sanitizedSpecDescription.concat(': ');

			// checking against 'false' in case pref doesn't exist and is not false
			// because 'true' is the default state
			if (isSpecDescriptionMuted !== 'false') {
				specItemDescriptionClasses.push('text-muted');
			}
		}

		return (
			<li key={id} className="spec-item">
				<span
					className={specItemDescriptionClasses.join(' ')}
					dangerouslySetInnerHTML={{
						__html: sanitizedSpecDescription
					}}
				/>
				{!!specDetail && (
					<span
						className="spec-item-detail"
						dangerouslySetInnerHTML={{
							__html: sanitizedSpecDetail
						}}
					/>
				)}
				{!!sanitizedSpecDisclaimers && (
					<div
						className={`spec-item-disclaimers text-muted ddc-font-size-${disclaimerFontSize}`}
						dangerouslySetInnerHTML={{
							__html: sanitizedSpecDisclaimers
						}}
					/>
				)}
			</li>
		);
	});

export default class SpecDescription extends React.Component {
	render() {
		const { prefs, specIds, specification } = this.props;

		const specObj = specification.reduce(
			(obj, itm) => ({
				...obj,
				[itm.id]: itm.spec
			}),
			{}
		);

		return (
			<React.Fragment>
				<ul className="spec-list list-unstyled list-spaced line-height-condensed mt-4 ml-2 pl-5">
					{renderSpecDescription(prefs, specIds, specObj)}
				</ul>
			</React.Fragment>
		);
	}
}

SpecDescription.propTypes = {
	prefs: PropTypes.shape({
		disclaimerFontSize: PropTypes.string,
		isSpecDescriptionMuted: PropTypes.string
	}),
	specIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	specification: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			spec: PropTypes.object.isRequired
		})
	).isRequired
};

SpecDescription.defaultProps = {
	prefs: {
		disclaimerFontSize: 'xxsmall',
		isSpecDescriptionMuted: 'true'
	}
};



// WEBPACK FOOTER //
// ./src/components/SpecDescription.jsx